import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './App'

/**
 * Entry point.
 *
 * No Polaris CSS import and no theme provider, Polaris web components come from the App
 * Bridge script and style themselves from the admin's own design tokens, so the app inherits
 * the merchant's admin appearance (including their dark mode) for free.
 */

const container = document.getElementById('root')
if (!container) throw new Error('#root missing from index.html')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
